<ngx-ui-loader [loaderId]="PROCESS_IMG_LOADER_ID"></ngx-ui-loader>
<div class="prescription-container">
  <div class="row">
    <div class="col-md-12">
      <h1>Upload Your Photo</h1>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 prescription-box">
      <h2>Selected PD Method</h2>
      <div class="photo-files">
        <ul>
          <li>
            {{ isManualPD ? 'PD added by the user.' : 'PD calculation provided by Eyelation.' }}
          </li>
        </ul>
      </div>
      @if (!isKiosk) {
        <div>
          <h2 class="photo-header">Please upload your photo in .jpeg, .png, or .bmp format.</h2>
          <div class="prescription-upload desktop-wrapper">
            <p>Drag and drop your file below</p>
            <div class="upload-box"
              appDragDropFileUpload
              (fileDropped)="onFileDrop($event)">
              <span class="text-inside">Directly place file here.</span>
            </div>
            <div class="form-group">
              <label for="exampleFormControlFile1">Or browse and select the file you want to upload</label>
              <div class=" file-input-row row">
                <div class="col-8">
                  <div class="input-group file-input-group mb-3" (click)="fileInput.click()">
                    <div class="input-group-prepend">
                      <span class="form-control input-group-text file-group-text"
                      id="inputGroup-sizing-default">Browse&hellip;</span>
                    </div>
                    <input type="text" class="form-control" readonly aria-label="Default"
                      aria-describedby="inputGroup-sizing-default" [(ngModel)]="filename">
                    <input #fileInput type="file" aria-label="Default" (change)="onFileChange($event)"
                      aria-describedby="inputGroup-sizing-default">
                  </div>
                </div>
                <div class="col-4">
                  <button class="btn btn-block gray-btn" type="button" (click)="submit()">Upload</button>
                </div>
              </div>
            </div>
            @if (isSubmitted && !isValidFile) {
              <div class="invalid-feedback" [ngClass]="{ 'd-block': isSubmitted && !isValidFile }"
                >
                Invalid file, please check that the file has one of this format: .jpeg, .jpg, .png, .bmp .
              </div>
            }
          </div>
          <div #photoMobile class="photo-upload mobile-wrapper row">
            <div class="col btn-wrapper">
              @if (!isPhotoReady) {
                <div>
                  <button class="btn btn-block gray-btn" type="button" (click)="fileInput.click()">Browse&hellip;</button>
                  <button class="btn-block white-btn" type="button" (click)="cameraPhoto.click()">Take Photo</button>
                </div>
              } @else {
                <button class="btn-block gray-btn" type="button" (click)="submit()">Upload</button>
                <button class="btn-block white-btn" type="button" (click)="switchPhotoStatus()">Back</button>
              }
              <ng-template #photoReady>
                <button class="btn-block gray-btn" type="button" (click)="submit()">Upload</button>
                <button class="btn-block white-btn" type="button" (click)="switchPhotoStatus()">Back</button>
              </ng-template>
              <input #cameraPhoto id="photoUploadFromCamera" (change)="onFileChange($event)" type="file"
                accept="image/*" style="display: none;">
              </div>
            </div>
          </div>
        }

        <!-- KIOK MODE -->
        @if (isKiosk) {
          <div>
            <div class="photo-upload kiosk-wrapper">
              <h2 class="photo-header">Upload your photo.</h2>
              <div>
                <div class="col">
                  <p>Please take your photo. Your photo will be scaled by our system to ensure we can check for a proper
                  fit.</p>
                </div>
              </div>
              <div>
                <div class="col">
                  <h3>For Best Results..</h3>
                  <ol>
                    <li>Take your glasses off.</li>
                    <li><b>When the countdown starts, look straight into the camera.</b></li>
                    <li>Take a photo with just you in the picture.</li>
                  </ol>
                </div>
              </div>
              <div>
                <div class="col btn-wrapper mt-2">
                  <button class="btn-block gray-btn" type="button" (click)="openKioskCameraClick()">Open Camera</button>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
    </div>
  </div>

  @if (isKiosk) {
    @if (isCameraOpen) {
      <app-kiosk-camera
        [cameraType]="FRONT_CAMERA"
        (cameraTimeout)="testTimeOut()"
      (capturedPhoto)="onCapturedPhoto($event)"></app-kiosk-camera>
    }
  }

  <ng-template #instructionModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">For Best Results...</h5>
      <!-- <button type="button" class="close" (click)="instructionModalRef?.close()">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center">
      <ol>
        <li>Use a photo with your glasses off.</li>
        <li>Use a photo with just you in the picture.</li>
      </ol>
    </div>
    <div class="d-flex justify-content-center flex-wrap">
      <img src="../assets/images/example1.png" class="img-fluid">
      <img src="../assets/images/example2.png" class="img-fluid">
      <img src="../assets/images/example3.png" class="img-fluid">
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn gray-btn" (click)="instructionModalRef?.close()">Close</button>
  </div>
</ng-template>

<ng-template #photoPreviewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Success</h5>
  </div>
  <div class="modal-body text-center">
    <h5>Your photo has been updated.</h5>
    <app-secure-image [filename]="previewImageName"
      [hasThumbnail]="false"
      [style]="'preview-image'">
  </app-secure-image>
</div>
<div class="modal-footer justify-content-between">
  <button type="button" class="btn gray-btn" (click)="onTryAgainClick()">Try Again</button>
  <button type="button" class="btn gray-btn" (click)="onContinueClick()">Continue</button>
</div>
</ng-template>

<ng-template #errorsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Unable to process your photo.</h5>
  </div>
  <div class="modal-body text-center">
    @for (e of errors; track $index) {
      <div class="alert alert-warning">
        {{ e.description }}
      </div>
    }
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn gray-btn" (click)="onCloseErrorModal()">Close</button>
  </div>
</ng-template>
